module.exports = __webpack_public_path__ + "img/ttwo.8b9c7e54.png";